import * as Ux from '../util/ux_message'
import UxMessageModal from '../pmd/components/util/UxMessageModal.vue'
import { h, render } from 'vue'

export default {
  install(app, { rootSelector } = { rootSelector: '#app' }) {
    let uxMessageInstance = null
    let container = null

    app.config.globalProperties.$uxMessage = (
      type,
      message,
      callbackFunction,
      options = { isMessageInRawHTML: false }
    ) => {
      let uxMessageItem
      if (type === 'confirmation' || type === 'consent') {
        uxMessageItem = Ux.UxMessage[`${type}Type`](message, callbackFunction, options)
      } else {
        uxMessageItem = Ux.UxMessage[`${type}Type`](message)
      }

      if (uxMessageInstance?.proxy) {
        uxMessageInstance.proxy.show(uxMessageItem, options.isMessageInRawHTML || false)
        return
      }

      // Create container if it doesn't exist
      if (!container) {
        container = document.createElement('div')
        document.querySelector(rootSelector).appendChild(container)
      }

      // Create vnode and mount component
      // Attach the root app context so that global
      // properties & plugins (like vue-i18n's $t)
      // are available inside UxMessageModal.
      const vnode = h(UxMessageModal)
      vnode.appContext = app._context
      render(vnode, container)
      uxMessageInstance = vnode.component

      // Show the message
      uxMessageInstance.proxy.show(uxMessageItem, options.isMessageInRawHTML || false)
    }

    // Add cleanup method
    app.config.globalProperties.$uxMessageCleanup = () => {
      if (container) {
        render(null, container)
        container.remove()
        container = null
        uxMessageInstance = null
      }
    }
  },
}
